module.exports = __webpack_public_path__ + "img/renyuan.29a02daf.png";